import { loadingReducers, LoadingState } from './base/baseModelStore';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { httpClient } from '../infrastructure/http/HttpClient';
import { Clusters } from '../api-model/models';
import { AppThunk } from '@root/store/store';
import { Bounds } from 'models/boundsCorners';
import { parseBoundsToCorners } from '@features/dashboard/sites-map/SiteMap.utils';

export interface ClustersState extends LoadingState {
  clustersData: Clusters;
}

const loadingClustersSuccess = (state: ClustersState, { payload }: PayloadAction<Clusters>) => {
  state.clustersData = payload;
  state.loading = false;
};

const slice = createSlice({
  name: 'clusters',
  initialState: {
    loading: false,
    error: null,
    clustersData: {},
  } as ClustersState,
  reducers: {
    ...loadingReducers,
    loadingClustersSuccess,
  },
});

const actions = slice.actions;

const fetchClusters = (bounds?: Bounds | null, accountId?: number | null): AppThunk => async (dispatch) => {
  const corners = parseBoundsToCorners(bounds);

  dispatch(actions.startLoading());

  try {
    const locationParams = bounds
      ? `topLeftLat=${corners.topLeft.lat}&topLeftLng=${corners.topLeft.lng}&bottomRightLat=${corners.bottomRight.lat}&bottomRightLng=${corners.bottomRight.lng}`
      : '';
    const accountIdPParam = accountId ? `accountId=${accountId}` : '';

    const url = `Chambers/map/clusters?${locationParams}${locationParams ? `&${accountIdPParam}` : accountIdPParam}`;

    const { data } = await httpClient.get<Clusters>(url);

    if (data) {
      dispatch(actions.loadingClustersSuccess(data));
    }
  } catch (err) {
    dispatch(actions.loadingFailed(err.toString()));
  }
};

const thunks = { fetchClusters };

export const clustersEntity = {
  reducer: slice.reducer,
  actions,
  thunks,
} as {
  reducer: typeof slice.reducer;
  actions: typeof actions;
  thunks: typeof thunks;
};
